import { render, staticRenderFns } from "./WantCarousel.vue?vue&type=template&id=3cba40d2&scoped=true"
import script from "./WantCarousel.vue?vue&type=script&lang=js"
export * from "./WantCarousel.vue?vue&type=script&lang=js"
import style0 from "./WantCarousel.vue?vue&type=style&index=0&id=3cba40d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cba40d2",
  null
  
)

export default component.exports